export const getSystem = state => state.system;
